//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    step: {
      type: Number,
      default: 1
    },
    totalstep: {
      type: Number
    }
  },
  data () {
    return {
      stepArry: [],
      stepwidth: 0,
      pad: 48
    }
  },
  created () {
    for (let i = 0; i < this.totalstep; i++) {
      this.stepArry.push(i)
    }
  },
  mounted () {
    let pad = parseInt(this.$refs.step.style.paddingLeft)
    let lineWidth = window.innerWidth - pad * 2
    this.stepwidth = lineWidth / (this.totalstep - 1)
  },
  computed: {
    padStyle () {
      return {
        'padding-left': this.pad + 'px',
        'padding-right': this.pad + 'px'
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/baseComponents/MyStep.vue